import { useMemo } from 'react'
import type { DocumentData } from 'firebase/firestore'
import { useCollection } from '@/hooks/useFirestore'
import { toBusiness, toUser } from '@/lib/normalize'
import type { Business, User } from '@/types'

/** All users, normalised (see lib/normalize.ts). Shares the `['users']` query cache. */
export function useUsers() {
  const query = useCollection<DocumentData>('users')
  const data = useMemo<User[] | undefined>(
    () => query.data?.map(({ id, ...rest }) => toUser(id, rest)),
    [query.data]
  )
  return { ...query, data }
}

/** All care circles, normalised. Shares the `['businesses']` query cache. */
export function useBusinesses() {
  const query = useCollection<DocumentData>('businesses')
  const data = useMemo<Business[] | undefined>(
    () => query.data?.map(({ id, ...rest }) => toBusiness(id, rest)),
    [query.data]
  )
  return { ...query, data }
}
